import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeAnalytics, setAnalyticsUserId, trackPageView } from '../services/analytics';

export default function AnalyticsTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    initializeAnalytics();
    setAnalyticsUserId(localStorage.getItem('user_id'));
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
